import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { THEME } from '@/common/styles/theme';
import { HOME_BANNER_MOBILE_ASPECT_RATIO } from '../../config/homeBanners.config';

export const HOME_BANNER_HEIGHT = 256;

export const BannerSection = styled.section`
	position: relative;
	width: 100%;
	min-width: 0;
	padding: 16px min(5vw, 64px) 14px;
	display: flex;
	justify-content: center;
	background: ${THEME.bg};
	border-bottom: 1px solid rgba(246, 142, 255, 0.08);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 0;
		display: block;
	}
`;

export const BannerViewport = styled.div`
	position: relative;
	overflow: hidden;
	width: 100%;
	height: ${HOME_BANNER_HEIGHT}px;
	border-radius: 24px;
	border: 1px solid ${THEME.line};
	box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42);
	background: #070509;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		height: auto;
		aspect-ratio: ${(props) =>
			props.$aspectRatio || `${HOME_BANNER_MOBILE_ASPECT_RATIO} / 1`};
		border-radius: 0;
		border: 0;
		box-shadow: none;
		background: transparent;
	}
`;

export const BannerTrack = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	transform: translate3d(-${(props) => props.$trackIndex * 100}%, 0, 0);
	transition: ${(props) =>
		props.$durationMs > 0
			? `transform ${props.$durationMs}ms ease`
			: 'none'};
	backface-visibility: hidden;
`;

export const BannerSlide = styled.div`
	flex: 0 0 100%;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: stretch;
	justify-content: center;
`;

export const BannerLink = styled.a`
	display: block;
	width: 100%;
	height: 100%;
`;

export const BannerRouterLink = styled(Link)`
	display: block;
	width: 100%;
	height: 100%;
`;

export const BannerPicture = styled.picture`
	display: block;
	width: 100%;
	height: 100%;
`;

export const BannerImage = styled.img`
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
	backface-visibility: hidden;
	transform: translateZ(0);
`;
